<template>
  <!-- Table -->
  <v-data-table
    v-model="selected"
    :headers="tableHeaders"
    :items="query.data"
    :server-items-length="query.length"
    :options.sync="query.options"
    :loading="query.loading"
    item-key="_id"
    show-select
    disable-sort
    dense
    class="elevation-2 rounded-lg grow text-truncate"
    style="border-color: red !important"
  >
    <!-- Table Header -->
    <template v-slot:top>
      <v-row no-gutters class="pa-3">
        <span class="text-h6">Product Approval</span>
        <v-spacer></v-spacer>

        <!-- Option Button -->
        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              :disabled="!selected.length"
              :dark="!!selected.length"
              small
              depressed
              class="rounded-xl lighten-1"
              color="cyan"
              v-on="on"
              v-bind="attrs"
              >Option</v-btn
            >
          </template>

          <!-- Option Menu -->
          <v-list dense>
            <v-list-item @click="updateMany(true)">
              <v-list-item-title>
                <v-icon small left>mdi-checkbox-marked-circle</v-icon>
                Confirm
              </v-list-item-title>
            </v-list-item>
            <v-list-item disabled>
              <v-list-item-title>
                <v-icon small left>mdi-close-circle</v-icon>
                Ignore
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>

        <v-btn small depressed disabled class="rounded-xl cyan lighten-1 ml-1"
          >Filter</v-btn
        >
      </v-row>
    </template>

    <!-- Product Title -->
    <template v-slot:item.title="{ item: { title, _id, type } }">
      <a :href="`/${type}/p/${_id}?admin=true`" target="_blank">
        {{ title }}
      </a>
    </template>

    <!-- Price -->
    <template v-slot:item.price="{ item: { price } }">
      {{ price.toLocaleString() }}
    </template>

    <!-- Store -->
    <template v-slot:item.store.storeName="{ item: { store } }">
      <a
        v-if="store"
        :href="`/stores/s/${store._id}?admin=true`"
        target="_blank"
        >{{ store.storeName }}</a
      >
    </template>

    <!-- Post DateTime -->
    <template v-slot:item.createdAt="{ item: { createdAt } }">
      {{
        new Date(createdAt).toLocaleString($langs.lang, {
          day: "2-digit",
          month: "2-digit",
          year: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
        })
      }}
    </template>

    <!-- Actions -->
    <template v-slot:item.actions="{ item }">
      <template v-if="!item.status.detail">
        <v-btn
          small
          icon
          @click="updateOne(item, true)"
          :disabled="query.loading"
        >
          <v-icon small> mdi-checkbox-marked-circle </v-icon>
        </v-btn>
        <v-icon small @click="updateOne(item, false)" :disabled="query.loading">
          mdi-close-circle
        </v-icon>
      </template>
      <template v-else>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <span class="grey--text" v-bind="attrs" v-on="on">Pending</span>
          </template>
          <span>Admin feedback:<br />{{ item.status.detail }}</span>
        </v-tooltip>
      </template>
    </template>
  </v-data-table>
</template>

<script>
import admin from "../../../services/admin";
import api from "../../../services/api";

export default {
  data() {
    return {
      query: {
        data: [],
        length: 0,
        options: null,
        loading: false,
      },
      tableHeaders: [
        { text: "Product Name", value: "title" },
        { text: "Price", value: "price" },
        { text: "Type", value: "type" },
        { text: "StoreName", value: "store.storeName" },
        { text: "Post", value: "createdAt" },
        { text: "Actions", value: "actions" },
      ],
      selected: [],
    };
  },
  mounted() {
    // this.fetchData();
  },
  methods: {
    async fetchData() {
      // Call API
      this.query.loading = true;
      let { itemsPerPage, page } = this.query.options;
      let params = {
        count: this.query.length == 0,
        size: itemsPerPage,
        page,
        valid: false,
      };
      let result = await admin.getProduct(params);
      this.query.data = result.products;
      if (result.amount) this.query.length = result.amount;
      this.query.loading = false;
    },
    async updateMany(value) {
      const data = this.selected.map(({ _id }) => ({ _id, valid: value }));
      this.selected = [];

      let { success, msg } = await admin.updateProduct(data);
      if (!success) return api.makeAlert(msg, "error");
      api.makeAlert("Update record successfully", "success");
      this.selected = [];

      this.fetchData();
    },
    async updateOne(item, value) {
      const _id = item._id || item.product._id;
      const data = [{ _id, valid: value }];
      if (value === false) {
        let detail = prompt("Give a short detail for this action!");
        if (!detail) return api.makeAlert("Cancel this action.", "secondary");
        data[0].detail = detail;
      }

      let { success, msg } = await admin.updateProduct(data);
      if (!success) return api.makeAlert(msg, "error");
      api.makeAlert("Update record successfully", "success");
      this.selected = [];
      this.fetchData();
    },
  },
  watch: {
    "query.options": function () {
      this.fetchData();
    },
  },
};
</script>

<style>
</style>